import * as React from 'react';
import { observer } from 'mobx-react';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { toggleDeviceDetailsWindow } from '../mutators/toggleDeviceDetailsWindow';
import { MobileDeviceDetailsType } from '../store/schema/MobileDeviceDetailsType';
import strings from 'owa-strings/owa-options-strings';

export interface MobileDeviceDetailsProps {
    deviceDetails: MobileDeviceDetailsType;
}

const styles = require('./MobileDeviceDetails.scss');

interface DetailsRowProps {
    label: string;
    value: string | number;
}

function DetailsRow(props: DetailsRowProps) {
    return (
        <div className={styles.propertyRow}>
            <Label className={styles.propertyName}>{props.label}</Label>
            <Label className={styles.propertyValue}>{props.value}</Label>
        </div>
    );
}

export default observer(function MobileDeviceDetails(props: MobileDeviceDetailsProps) {
    return (
        <div className={styles.propertyContainer}>
            <DetailsRow
                label={strings.options_mobile_details_statusLabel}
                value={props.deviceDetails.status}
            />
            <DetailsRow
                label={strings.options_mobile_details_firstSyncLabel}
                value={props.deviceDetails.firstSyncTime}
            />
            <DetailsRow
                label={strings.options_mobile_details_lastSuccessfulSyncLabel}
                value={props.deviceDetails.lastSuccessSync}
            />
            <DetailsRow
                label={strings.options_mobile_details_foldersSyncedLabel}
                value={props.deviceDetails.folderSynced}
            />
            <DetailsRow
                label={strings.options_mobile_details_deviceNameLabel}
                value={props.deviceDetails.deviceName}
            />
            <DetailsRow
                label={strings.options_mobile_details_deviceModelLabel}
                value={props.deviceDetails.deviceModel}
            />
            <DetailsRow
                label={strings.options_mobile_details_phoneNumberLabel}
                value={props.deviceDetails.phoneNumber}
            />
            <DetailsRow
                label={strings.options_mobile_details_mobileNetworkLabel}
                value={props.deviceDetails.mobileNetwork}
            />
            <DetailsRow
                label={strings.options_mobile_details_deviceTypeLabel}
                value={props.deviceDetails.deviceType}
            />
            <DetailsRow
                label={strings.options_mobile_details_deviceIdLabel}
                value={props.deviceDetails.deviceID}
            />
            <DetailsRow
                label={strings.options_mobile_details_deviceImeiLabel}
                value={props.deviceDetails.deviceIMEI}
            />
            <DetailsRow
                label={strings.options_mobile_details_deviceOsLabel}
                value={props.deviceDetails.deviceOS}
            />
            <DetailsRow
                label={strings.options_mobile_details_deviceLanguageLabel}
                value={props.deviceDetails.deviceLanguage}
            />
            <DetailsRow
                label={strings.options_mobile_details_userAgentLabel}
                value={props.deviceDetails.userAgent}
            />
            <DetailsRow
                label={strings.options_mobile_details_accessStateLabel}
                value={props.deviceDetails.accessState}
            />
            <DetailsRow
                label={strings.options_mobile_details_accessSetByLabel}
                value={props.deviceDetails.accessSetBy}
            />
            <DetailsRow
                label={strings.options_mobile_details_clientTypeLabel}
                value={props.deviceDetails.clientType}
            />
            <DetailsRow
                label={strings.options_mobile_details_protocolVersionLabel}
                value={props.deviceDetails.protocolVersion}
            />
            <PrimaryButton className={styles.okButton} onClick={toggleDeviceDetailsWindow}>
                {strings.options_mobile_details_okButton}
            </PrimaryButton>
        </div>
    );
});
